import { Task } from "../../../common/model/Task";
import { Checklist } from "../Checklist";

export class ChecklistDto {
    checklist: Checklist;
    newChecklist: boolean;
    newNotificationDoc: boolean;
    notificationDocument:any;
    stores: any[];
    task: Task = new Task();
    taskSchedule: any
}